import React from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import PropTypes from 'prop-types';

class CategoryQuestionList extends React.Component {

  constructor(props) {
    super(props);
    this.showIndicator = this.showIndicator.bind(this);
    this.state = {
      showIndicator: false
    }
    this.childNodes = {};
    this.registerChild = this.registerChild.bind(this);
    this.updateIndicator = this.updateIndicator.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  renderChildren(children, question, questionLookup) {
    var answers = [...question.answers];
    // let answers = question.answers;
    if (question.answerType === 'satisfiedBy') {
      answers = [];
      let relatedQuestions = question.satisfiedBy.map((id) => {
        return questionLookup[id]
      });
      for (let related of relatedQuestions) {
        for (let a of related.answers) {
          answers.push({
            ...a,
            title: related.title + ": " + a.title
          })
        }
      }
    }
    return React.Children.map(children, (child) => {
      return React.cloneElement(child, {
        ...question,
        answers: answers,
        ref: (child) => this.childNodes[question.id] = child,
        onUpdate: this.updateIndicator
      });
    });
  }

  getChildren() {
    return Object.keys(this.childNodes).map((k) => this.childNodes[k]);
  }

  registerChild(id, child) {
    if(!child) {
      delete this.childNodes[id]
    } else {
      this.childNodes[id] = child;
    }
  }

  componentDidMount() {
    this.updateIndicator();
  }

  updateIndicator() {
    this.showIndicator(this.shouldShowIndicator(Object.keys(this.childNodes).map((k) => this.childNodes[k])));
  }

  shouldShowIndicator(children) {
    return !!children.find((child) => {
      if (child.showParentIndicator && child.showParentIndicator()) {
        return true;
      } else {
        return false;
      }
    });
  }

  render() {
    let props = this.props;
    return (
      <Card onExpandChange={this.toggleExpanded}>
        <CardHeader
          avatar={this.state.showIndicator ? <Avatar backgroundColor="rgb(109, 178, 217)" size={10}  /> : <Avatar style={{border: "1px solid #d9d9d9"}} backgroundColor="white" size={10}  />}
          title={props.title}
          actAsExpander={props.expandable}
          showExpandableButton={props.expandable} />
        <CardText style={{display: this.state.expanded ? 'block' : 'none'}}>
        {
          props.questions.map((question) => (
            <div key={question.id}>
              <CardHeader title={question.title.replace(/<.*?>/gm, '')} />
              {this.renderChildren(props.children, question, props.questionLookup)}
            </div>
          ))
        }
        </CardText>
      </Card>
    )
  }

  showIndicator(toggle=true) {
    this.setState({showIndicator: toggle});
  }

  toggleExpanded() {
    this.setState({expanded: !this.state.expanded})
  }
}

class CategorizedQuestionList extends React.Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.categories !== nextProps.categories ||
      this.props.questions !== nextProps.questions ||
      this.props.expandable !== nextProps.expandable ||
      this.props.answers !== nextProps.answers;
  }

  getChildren() {
    return Object.keys(this.refs).reduce((children, key) => {
      let list = this.refs[key];
      return children.concat(list.getChildren());
    }, []);
  }

  render() {
    let props = this.props;
    return (
      <div>
      {
        props.categories.map((category) => {
          return <CategoryQuestionList
                     key={"cat" + category.id}
                     ref={"cat"+category.id}
                    {...category}
                    questions={props.questions.filter((q) => q.category === category.id)}
                    questionLookup={props.questions.reduce((l, q) => {l[q.id] = q; return l}, {})}
                    expandable={props.expandable}
                    >{props.children}</CategoryQuestionList>
        })
      }
      </div>
    )
  }

  showIndicator() {

  }

}

CategorizedQuestionList.propTypes = {
  questions: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
}

CategorizedQuestionList.defaultProps = {
  expandable: true
}

export default CategorizedQuestionList;
